export default __webpack_public_path__ + "static/media/logo_head.34e70ee4.png";